// ── iOS touch fixes ──────────────────────────────────────────
// Runs once per page load: the entrypoint is on every page, the chat itself
// lives in a turbo-permanent drawer or on the /chat route.
export function applyIosFixes() {
  if (window._bryghtChatIosFixesApplied) return;
  window._bryghtChatIosFixesApplied = true;

  preventPagePanInsideChat();
}

// The drawer, and the /chat route once a conversation covers the bottom nav.
const CHAT_SURFACE = ".global-chat-drawer, body.chat-route-active .bryght-chat-container.is-room-active";

// iOS pans the page when a finger drags on something that does not scroll
// itself, and with the keyboard open the layout viewport is taller than the
// visible one — a drag on the header or the composer would pan the chat.
// Elements that scroll (timeline, room list, details panel) and text inputs
// keep their native touch behaviour.
function preventPagePanInsideChat() {
  let touchStartX = 0;
  let touchStartY = 0;

  document.addEventListener("touchstart", (e) => {
    if (!e.target.closest(CHAT_SURFACE)) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener("touchmove", (e) => {
    const surface = e.target.closest(CHAT_SURFACE);
    if (!surface) return;
    if (scrollsItself(e.target, surface)) return;

    if (e.target.closest("input, textarea")) {
      // Vertical drags on an input pan the page; horizontal ones select text.
      const diffY = Math.abs(e.touches[0].clientY - touchStartY);
      const diffX = Math.abs(e.touches[0].clientX - touchStartX);
      if (diffY > diffX) e.preventDefault();
      return;
    }

    e.preventDefault();
  }, { passive: false });
}

// True when an element between `target` and `surface` is a scroll container
// that has something to scroll.
function scrollsItself(target, surface) {
  for (let el = target; el && el !== surface; el = el.parentElement) {
    const overflowY = getComputedStyle(el).overflowY;
    if ((overflowY === "auto" || overflowY === "scroll") && el.scrollHeight > el.clientHeight) {
      return true;
    }
  }
  return false;
}
